import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}


export default {
    rptbs(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['layout', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/consolbs/rptbs${str}`;
                const { data } = await axios.get(url);
                resolve(data[0]);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    rptbsprint(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['layout', 'tgl1', 'tgl2'];

                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                const url = `/consolbs/rptbsprint${str}`;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    rptbsexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['layout', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                let response = await axios({
                    url: `/consolbs/rptbsexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Balance_sheet_${obj.tgl2}.xlsx`);
                document.body.appendChild(link);
                link.click();
                resolve(link);
            } catch (error) {
                let responseObj = await error.response.data.text();
                errorHandler(JSON.parse(responseObj), reject);
            }
        });
    },
    layout(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                // const { data } = await axios.get(`incomestat/layout/${encodeURIComponent(obj.layout)}`);
                const { data } = await axios.get(`consolbsfmt/${encodeURIComponent(obj.layout)}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    layout_combo() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`consolbsfmt/combo`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    layoutDel(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.delete(`consolbsfmt/${encodeURIComponent(obj.layout)}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    layoutSave(data) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post("consolbsfmt", data);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    layoutSet(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                // const { data } = await axios.get(`incomestat/layout/${encodeURIComponent(obj.layout)}`);
                const { data } = await axios.get(`bsfmt/setting/${encodeURIComponent(obj.layout)}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }
};